import React, { useState, useContext, useEffect } from 'react'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import AuthContext from '@/product/context/auth/authContext'
import InvoiceCard from '@/custom/components/molecules/InvoiceCard'
import NoRecordsFound from '@/custom/components/atoms/NoRecordsFound'
import { Pagination } from '@material-ui/lab'
import DashboardLayout from '@/views/Dashboard/DashboardLayout'
import CustomTable from '@/product/components/molecules/CustomTable'
import { mapData } from '@/product/common/components'
import * as Yup from 'yup'
import {
    dateTimeFormatFunction,
    capitalize,
    paymentTypeRosoom,
    dateFormatFrontOnlyDate,
    handleRedirectInternal,
    currencyFormat,
} from '@/custom/common/components'
import Lottie from 'react-lottie'
import successAnimation from '../../../../lottie/successAnimation.json'
import { useHistory } from 'react-router-dom'
import ProductContext from '@/product/context/product/productContext'
import { Button, ListItem } from '@material-ui/core'
import { useFormik } from 'formik'
import SEO from '@/utils/SEO'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/custom/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Scheduler from './schedule'
import SchedulePickupContext from '@/product/context/schedulePickup/schedulePickupContext'
import AlertContext from '@/product/context/alert/alertContext'

const bull = (
    <Box component="span" sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}>
        •
    </Box>
)

const CheckIn = (props) => {
    let [viewProduct, setViewProduct] = useState([])
    const [tableBody, setTableBody] = useState([])
    const [dataArray, setDataArray] = useState([])
    const [parkLotData, setParkLotData] = useState([])
    const [pickupPopup, setPickupPopup] = useState(false)
    const authContext = useContext(AuthContext)
    const invoiceContext = useContext(InvoiceContext)
    const { search_alluserinvoices, getAllUserInvoices } = invoiceContext
    const scheduleContext = useContext(SchedulePickupContext)
    const { addSchedulePickup, responseStatus, clearResponse } = scheduleContext
    const customCommonContext = useContext(CustomCommonContext)
    const { setCurrentMembership, allBiddingPlan, membership, alldata_all_dropdown, allLocations } =
        customCommonContext
    const productContext = useContext(ProductContext)
    const {
        search_alldashboardproducts,
        getAllDashboardProducts,
        responseStatus: responseStatusProduct,
    } = productContext
    const { user, isAuthenticated } = authContext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [isLoading, setIsLoading] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [selectedLocation, setSelectedLocation] = useState([])
    const [dateCalendar, setDateCalendar] = useState(false)
    const [customDate, setCustomDate] = useState(false)
    const history = useHistory()

    const validationArray = Yup.object({
        // color: Yup.string().required('Required'),
        parking_lot_no: Yup.string().when('type', {
            is: (a) => a == 2,
            then: Yup.string().required('Required!'),
        }),
        // car_make: Yup.string().required('Required'),
        // model: Yup.string().required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            location_id: '',
            parking_lot_no: '',
            car_make: '',
            type: 1,
            model: '',
            color: '',
            reschedule: 1,
            schedule_status: 'waiting',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            let allInvoiceId = []
            if (values.id.length) {
                values.id.map((data) => {
                    if (!allInvoiceId.includes(data)) {
                        allInvoiceId.push(data)
                    }
                })
            }
            values.id = allInvoiceId
            addSchedulePickup(values, 'checkin')
        },
    })

    const scheduleSuccessOptions = {
        loop: true,
        autoplay: true,
        speed: '0.25',
        animationData: successAnimation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    }

    const handlePickup = () => {
        setActiveStep(0)
        formik.handleReset()
        props.handleCheckPopup()
    }

    useEffect(() => {
        if (responseStatus && responseStatus.from === 'checkin') {
            setAlert(responseStatus.message, responseStatus.status)
            if (responseStatus.status === 'success') {
                setActiveStep(1)
                setTimeout(() => {
                    handlePickup()
                    props.getFunction()
                }, 1000)
            }
        }
        clearResponse()
    }, [responseStatus])

    useEffect(() => {
        formik.values.id = props.schedId
    }, [props.schedId])

    useEffect(() => {
        if (props.locationId && allLocations.length) {
            formik.values.location_id = props.locationId

            const parklot = allLocations
                .filter((item) => item.active == 1 && item.id == props.locationId)
                .map((data) => {
                    const allpark =
                        data.parking_slot && data.parking_slot.length
                            ? data.parking_slot.split(',').map((str) => str.trim())
                            : []

                    return allpark.map((item) => {
                        return {
                            show: item.toString(),
                            value: item,
                        }
                    })
                })
            setParkLotData(parklot[0])
        }
    }, [props.locationId, props.schedId, allLocations])

    useEffect(() => {
        if (user && Object.keys(user).length) {
            formik.values.user_id = user.id
        }
    }, [user, props.schedId])

    useEffect(() => {
        if (props.pickupData && props.pickupData.length) {
            const allData = props.pickupData[0]
            formik.values.type = allData.schedulepickup_type || 1
            formik.values.car_make = allData.schedulepickup_car_make || ''
            formik.values.model = allData.schedulepickup_model || ''
            formik.values.color = allData.schedulepickup_color || ''
            formik.values.parking_lot_no = allData.schedulepickup_parking_lot_no || ''
        }
    }, [props.pickupData])

    const checkinData = [
        {
            title: 'Check In',
            type: 'radio',
            name: 'type',
            item: [
                { id: 1, description: 'Office' },
                { id: 2, description: 'Parking Lot' },
            ],
            class: 'col-12',
            formik: formik,
            int: 1,
        },
        // {
        //     label: 'Car Make',
        //     name: 'car_make',
        //     type: 'text',
        //     placeholder: 'Enter Make',
        //     class: 'col-12',
        //     formik: formik,
        // },
        // {
        //     label: 'Model',
        //     name: 'model',
        //     type: 'text',
        //     placeholder: 'Enter Your Model',
        //     class: 'col-12',
        //     formik: formik,
        // },
        // {
        //     label: 'Color',
        //     placeholder: 'Enter your Car Color',
        //     class: 'col-12',
        //     type: 'text',
        //     name: 'color',
        //     formik: formik,
        // },
        {
            label: 'Parking Lot No',
            placeholder: 'Select Parking Lot no',
            class: `col-12 ${formik.values.type == 1 ? ' d-none' : ''}`,
            type: 'select',
            options: parkLotData,
            name: 'parking_lot_no',
            native: true,
        },
    ]

    return (
        <>
            <CustomDialog
                className="fileUploadModal"
                // title={'Schedule Pickup'}
                open={props.checkPopup}
                function={handlePickup}
                maxWidth="md"
            >
                {activeStep == 0 ? (
                    <>
                        <h3 className="fpTitle">Schedule Pickup</h3>
                        <div className="">
                            <div className="asdasd">
                                <div className="row">{Object.values(mapData(checkinData))}</div>
                                <PrimaryButton
                                    label="NEXT"
                                    btnSize="small"
                                    onClick={() => formik.handleSubmit()}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <h3 className="fpTitle text-center">Pickup Check Confirmed!</h3>
                        <Lottie
                            options={scheduleSuccessOptions}
                            speed="1"
                            height={100}
                            width={100}
                        />
                        <div className="py-3 text-center">
                            Your items are being Prepared for a smooth collection
                            <br />
                            We`ll notify you once everything is ready
                            <br />
                            Thank you for your patience!
                        </div>
                    </>
                )}
            </CustomDialog>
        </>
    )
}

export default CheckIn
